import { render, staticRenderFns } from "./BorcluSigortaBilgileri.vue?vue&type=template&id=54cce8ae"
import script from "./BorcluSigortaBilgileri.vue?vue&type=script&lang=ts"
export * from "./BorcluSigortaBilgileri.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports